import { dispatchEventDebounceInCollectionSearch } from '../analytic/main-thread';
import { debounce, isElementInViewport } from '../utils';

/**
 * @type {import('./index.d').requestInCollectionSearch}
 */
const requestInCollectionSearch = async (context, urlParams, inputElement) => {
  const [, setPage] = context.useContextState('pagination ', {});
  setPage({ page: 1 });
  urlParams.delete('page');

  window.history.replaceState({}, '', `${window.location.pathname}?${urlParams}`);
  // Disable input to prevent further typing
  inputElement.disabled = true;

  await context.getFilterApi(context.app.filterUrl, context.id, {
    additionParams: { inCollectionSearchFocusing: true },
  });

  dispatchEventDebounceInCollectionSearch(urlParams.get('q'));

  // Enable input back after search completes
  inputElement.disabled = false;
};

/**
 * @type {import('./index.d').handleInCollectionSearch}
 */
export const handleInCollectionSearch = (context, rootElement = document) => {
  context.render(() => {
    const inCollectionSearch = rootElement.querySelector('.boost-sd__in-collection-search-input');

    if (inCollectionSearch) {
      const urlParams = new URLSearchParams(window.location.search);
      const dataInputFocusing = inCollectionSearch.hasAttribute('data-input-focusing');
      const clearBtn = rootElement.querySelector('.boost-sd__in-collection-search-clear-btn');

      if (dataInputFocusing) {
        const end = inCollectionSearch.value.length;
        inCollectionSearch.setSelectionRange(end, end);

        // Only re-focus when the element is in the viewport to avoid scrolling to top
        if (isElementInViewport(inCollectionSearch)) {
          inCollectionSearch.focus();
        }
      }

      const delay = context.app?.generalSettings?.inCollectionSearchDelay || 500;

      inCollectionSearch?.addEventListener(
        'keyup',
        debounce(async (event) => {
          // set 'q' param in the URL
          if (event.target.value === '') {
            urlParams.delete('q');
          } else {
            urlParams.set('q', event.target.value);
          }

          await requestInCollectionSearch(context, urlParams, inCollectionSearch);
        }, delay)
      );
      clearBtn?.addEventListener('click', () => {
        urlParams.delete('q');
        requestInCollectionSearch(context, urlParams, inCollectionSearch);
      });
    }
  }, ['filterTree']);
};
